// extracted by mini-css-extract-plugin
module.exports = {"root":"SettingsDeletedSurveys_root__86GRG"};